module.exports = __webpack_public_path__ + "37a2c9e489c9fa3bb8fe49ef0d7b1f5c.svg";